module.exports = __webpack_public_path__ + "img/chat_gray.053ac748.svg";